module.exports = __webpack_public_path__ + "static/media/TYC_Socios_Promotores.9f7ce538.pdf";